import { PlainObject } from '@superset-ui/core';
import React, { createContext, useContext, useMemo, useState } from 'react';
import { Step } from 'react-joyride';

interface AppState {
  run: boolean;
  stepIndex: number;
  steps: Step[];
  tourActive: boolean;
  config?: PlainObject | null;
  joyride?: any;
  overlayClick: boolean;
}

const appState: AppState = {
  run: false,
  stepIndex: 0,
  steps: [],
  tourActive: false,
  overlayClick: false,
};

export const OnboardingContext = createContext({
  state: appState,
  setState: () => undefined,
});

OnboardingContext.displayName = 'OnboardingContext';

export function OnboardingProvider(props: any) {
  const [state, setState] = useState(appState);
  const value = useMemo(() => ({ state, setState }), [state, setState]);
  return <OnboardingContext.Provider value={value} {...props} />;
}

export function useOnboardingContext(): {
  setState: (
    patch: Partial<AppState> | ((previousState: AppState) => Partial<AppState>),
  ) => void;
  state: AppState;
} {
  const context = useContext(OnboardingContext);
  if (!context) {
    throw new Error(
      'useOnboardingContext must be used within a OnboardingProvider',
    );
  }

  return context;
}
